import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PgUiControlsModule } from '../pg-ui-controls/pg-ui-controls.module';
import { PgUiElementsModule } from '../pg-ui-elements/pg-ui-elements.module';
import { PgImportComponent } from './pg-import/pg-import.component';
import { PgImportJobComponent } from './pg-import-job/pg-import-job.component';
import { PgImportResourceComponent } from './pg-import-resource/pg-import-resource.component';
import { PgImportTreeComponent } from './pg-import-tree/pg-import-tree.component';
import { PgImportPreviewModalComponent } from './pg-import-preview-modal/pg-import-preview-modal.component';
import { PgImportedWidgetComponent } from './pg-imported-widget/pg-imported-widget.component';

@NgModule({
    declarations: [
        PgImportComponent,
        PgImportJobComponent,
        PgImportResourceComponent,
        PgImportTreeComponent,
        PgImportPreviewModalComponent,
        PgImportedWidgetComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        PgUiControlsModule,
        PgUiElementsModule,
        // NB: questi riferimenti vanno staccati, il modulo va isolato
    ],
    exports: [
        PgImportComponent,
        PgImportedWidgetComponent
    ]
})
export class PgImportModule { }
